import script from "./TableFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableFooter.vue?vue&type=script&setup=true&lang=ts"

import "./TableFooter.vue?vue&type=style&index=0&id=1ea6057d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ea6057d"]])

export default __exports__